import { Timestamp } from 'firebase/firestore';
import { GenerationStatus, SyncStatus } from '../constants/status';

export enum ShopifyShopStatus {
  CREATED = 'created',
  VALIDATED = 'validated',
  FAILED_TO_VALIDATE = 'failed to validate',
  SCRAPED = 'scraped',
  LANGUAGE_DETECTED = 'language detected',
  DESCRIPTION_CREATED = 'description created',
  METADATA_ANALYZED = 'metadata analyzed',
  EXTRACTING = 'extracting',
  ANALYZING = 'analyzing',
  DONE = 'done',
  ERROR = 'error',
  HIDDEN = 'hidden',
}

export interface ShopifyShopStats {
  productCount: number;
  imageCount: number;
  imageSyncStatusCount: Record<SyncStatus, number>;
  productSyncStatusCount: Record<SyncStatus, number>;
}

export interface ShopifyShopModel {
  id: string;
  userIds: string[];
  shop: string;
  shopUrl?: string;
  status: string;
  productCount?: number;
  iamgeCount?: number;
  llmLanguage?: string;
  llmKeywords?: string[];
  llmTargetAudience?: string;
  llmDescription?: string;
  shopifyTags?: string[];
  shopifyVendors?: string[];
  shopifyProductTypes?: string[];
  stats?: ShopifyShopStats;
  updatedAt: Timestamp;
  createdAt: Timestamp;
  createdBy?: string;
  updatedBy?: string;
}

export interface ShopifySEO {
  description?: string;
  title?: string;
}

export interface ShopifyProuctGeneration {
  allIncluded?: boolean;
  contradictoryFacts?: string[];
  language?: string;
  correctLanguage?: boolean;
  extractedFacts?: string[];
  descriptionHtml?: string;
  title?: string;
  missingFacts?: string[];
  partiallyIncluded?: string[];
  reasoning?: string[];
  selectedFacts?: string[];
  success?: boolean;
}

export interface ShopifyCount {
  count: number;
}

export interface ShopifyProduct {
  id: string;
  shopifyId: string;
  title: string;
  handle: string;
  descriptionHtml: string;
  shopifyStatus: string;
  productType: string;
  tags: string[];
  shopifyCreatedAt: Timestamp;
  shopifyUpdatedAt: Timestamp;
  vendor: string;
  seo?: ShopifySEO;
  variantsCount?: ShopifyCount;
  mediaCount?: ShopifyCount;
  generation?: ShopifyProuctGeneration;
  imageUrl?: string;
  syncStatus: SyncStatus;
  generationStatus?: GenerationStatus;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

export interface ShopifyImage {
  shopify_id: string;
  height?: string;
  width?: string;
  altText?: string;
  url?: string;
}

export interface ShopifyMediaPreview {
  image?: ShopifyImage;
  shopifyStatus?: string;
}

export interface ShopifyMediaGeneration {
  alt?: string;
  reasoning?: string;
  language?: string;
  title?: string;
  success?: boolean;
  correctLanguage?: boolean;
}

export interface ShopifyMedia {
  id: string;
  shopifyId: string;
  shopifyShopId: string;
  shopifyProductId: number;
  alt?: string;
  mediaContentType: string;
  preview?: ShopifyMediaPreview;
  shopifyStatus: string;
  productTitle: string;
  generation?: ShopifyMediaGeneration;
  syncStatus: SyncStatus;
  generationStatus?: GenerationStatus;
  updatedAt: Timestamp;
  createdAt: Timestamp;
}
